import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector     : 'simple-fullwidth-1-content-scroll',
    templateUrl  : './fullwidth-1.component.html',
    encapsulation: ViewEncapsulation.None
})
export class SimpleFullwidth1ContentScrollComponent
{
    /**
     * Constructor
     */
    constructor()
    {
    }
}
